module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAM1BMVEUAAAAAoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq/pmZr3AAAAEHRSTlMAwIBAv5BgMKDQbxDw4HAgJwloygAAAFpJREFUGNNtzFsOgCAMRNG2w0vw0f2vVkFpaOL5vMkMRTWBOi74nPoGIZIhhjYDUydlaz4gbdkHykdeQwUqLwHymMHMEHlIFpIMsJAxXH+ToqrulAC40O3B8A2qWQKUdBC89AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copy.png
// module id = OG1+
// module chunks = 1